// @flow
import type {
  BillingInfoOperator,
} from '../types'

// Constants
import { MODEL } from 'hfty-model-billing-info'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: BillingInfoOperator = composeOperator({
  model: MODEL,
  branch: 'billingInfoOperation',
})

export default operator
